/* QUOALA PDP v5 — Werkbank. Ohne Libraries. Alle Beobachter werden einmal registriert.
   Warum Netzwerk-Wache statt cart:updated: dieses Theme feuert das Ereignis nicht (Handover §10.6). */
(function () {
  'use strict';
  document.documentElement.classList.add('js');
  var root = document.querySelector('[data-q5]');
  if (!root) return;
  var cfg = {
    threshold: parseFloat(root.getAttribute('data-q5-threshold') || '70'),
    price: parseFloat(root.getAttribute('data-q5-price') || '0'),
    cutoff: parseInt(root.getAttribute('data-q5-cutoff') || '14', 10),
    transit: parseInt(root.getAttribute('data-q5-transit') || '2', 10),
    locale: (root.getAttribute('data-q5-locale') || 'de').slice(0, 2),
    reduced: !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) && !/[?&]motion=1/.test(location.search)
  };
  var T = {
    de: { by: 'Lieferung bis <b>{d}</b>', added: 'Im Warenkorb', add: 'In den Warenkorb', error: 'Das hat nicht geklappt — bitte nochmals versuchen.', days: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'] },
    en: { by: 'Delivery by <b>{d}</b>', added: 'Added', add: 'Add to cart', error: 'That didn’t work — please try again.', days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'] },
    fr: { by: 'Livraison d’ici <b>{d}</b>', added: 'Ajouté', add: 'Ajouter au panier', error: 'Cela n’a pas fonctionné — merci de réessayer.', days: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'] }
  }[cfg.locale] || null;
  if (!T) T = { by: 'Lieferung bis <b>{d}</b>', added: 'Im Warenkorb', add: 'In den Warenkorb', error: 'Das hat nicht geklappt — bitte nochmals versuchen.', days: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'] };
  function fmt(s, o) { return s.replace(/\{(\w+)\}/g, function (_, k) { return o[k]; }); }

  /* ---------- Lieferdatum: Cut-off + Transit in Werktagen, Europe/Zurich ---------- */
  (function delivery() {
    var el = root.querySelector('[data-q5-delivery]');
    if (!el) return;
    var now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Zurich' }));
    var ship = new Date(now);
    if (now.getHours() >= cfg.cutoff) ship.setDate(ship.getDate() + 1);
    while (ship.getDay() === 0 || ship.getDay() === 6) ship.setDate(ship.getDate() + 1);
    var d = new Date(ship);
    var left = cfg.transit;
    while (left > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) left--; }
    var label = T.days[d.getDay()] + ', ' + d.getDate() + '.' + (d.getMonth() + 1) + '.';
    el.innerHTML = '<span>' + fmt(T.by, { d: label }) + '</span>';
  })();

  /* ---------- Warenkorb-Total → Lücke bis Gratis-Versand (nur für «Ergänzt dein Ritual») ---------- */
  function renderProgress(cartTotal) {
    reorderRitual(Math.max(0, cfg.threshold - (cartTotal + cfg.price)));
  }
  /* ---------- Sticky-Leiste: Weg zum Gratisversand, nach dem Hinzufügen «Zur Kasse» (26.09., Greg) ---------- */
  var S = {
    de: { pre: 'Mit diesem Produkt noch <b>{g}</b> bis versandfrei ↓', gap: 'Noch <b>{g}</b> bis versandfrei ↓', free: 'Versandfrei ✓', preFree: 'Mit diesem Produkt versandfrei ✓', inCart: 'Im Warenkorb ✓', total: 'Total {t}' },
    en: { pre: 'With this product, <b>{g}</b> to free shipping ↓', gap: '<b>{g}</b> to free shipping ↓', free: 'Free shipping ✓', preFree: 'Ships free with this product ✓', inCart: 'In your cart ✓', total: 'Total {t}' },
    fr: { pre: 'Avec ce produit, encore <b>{g}</b> pour la livraison offerte ↓', gap: 'Encore <b>{g}</b> pour la livraison offerte ↓', free: 'Livraison offerte ✓', preFree: 'Livraison offerte avec ce produit ✓', inCart: 'Dans le panier ✓', total: 'Total {t}' }
  }[cfg.locale] || null;
  if (!S) S = { pre: 'Mit diesem Produkt noch <b>{g}</b> bis versandfrei ↓', gap: 'Noch <b>{g}</b> bis versandfrei ↓', free: 'Versandfrei ✓', preFree: 'Mit diesem Produkt versandfrei ✓', inCart: 'Im Warenkorb ✓', total: 'Total {t}' };
  var stickyInCart = false;
  function chf(x) { return 'CHF ' + x.toFixed(2); }
  function stickyCart(c) {
    var st = document.querySelector('[data-q5-sticky]'); if (!st) return;
    var add = st.querySelector('[data-q5-sticky-add]'), go = st.querySelector('[data-q5-sticky-go]');
    var vid = add ? +add.getAttribute('data-variant') : 0;
    var inCart = (c.items || []).some(function (i) { return i.variant_id === vid; });
    var cur = (c.total_price || 0) / 100, gap = cfg.threshold - cur;
    var hasPasst = !!document.querySelector('[data-q5p]');
    var nm = st.querySelector('.q5-sticky__name'), pr = st.querySelector('.q5-sticky__price'), msg = st.querySelector('[data-q5-sticky-msg]');
    if (!nm.hasAttribute('data-orig')) { nm.setAttribute('data-orig', nm.textContent); pr.setAttribute('data-orig', pr.textContent); }
    /* 26.09.: Leiste bleibt ruhig (Name · Preis · Knopf); die Versand-Lücke steht bei «Passt gut dazu» und im Warenkorb. */
    msg.hidden = true; pr.hidden = false; nm.hidden = false;
    st.classList.toggle('is-incart', inCart);
    stickyInCart = inCart;
    if (window.__q5StickyUpdate) window.__q5StickyUpdate();
  }
  document.addEventListener('click', function (e) {
    var m = e.target.closest('[data-q5-sticky-msg]'); if (!m || m.disabled) return;
    var t = document.querySelector('[data-q5p]'); if (t) t.scrollIntoView({ behavior: cfg.reduced ? 'auto' : 'smooth', block: 'start' });
  });
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  /* ---------- Vertrauenszeile: «Gratisversand ab CHF 70» rechnet mit dem Warenkorb (U30, 02.10.2026) ---------- */
  var FR_ = {
    de: { pre: '{g} bis Gratisversand', preFree: 'Gratisversand ✓', gap: '{g} bis Gratisversand', free: 'Gratisversand ✓' },
    en: { pre: '{g} to free shipping', preFree: 'Free shipping ✓', gap: '{g} to free shipping', free: 'Free shipping ✓' },
    fr: { pre: 'Port offert : encore {g}', preFree: 'Livraison offerte ✓', gap: 'Port offert : encore {g}', free: 'Livraison offerte ✓' }
  }[cfg.locale] || null;
  function freeLine(c) {
    var el = root.querySelector('[data-q5-free]'); if (!el || !FR_) return;
    var vid = +((root.querySelector('[data-q5-form] [name="id"]') || {}).value || 0);
    var inCart = (c.items || []).some(function (i) { return i.variant_id === vid; });
    var cur = (c.total_price || 0) / 100, gap = cfg.threshold - cur - (inCart ? 0 : cfg.price);
    el.textContent = gap > 0 ? fmt(inCart ? FR_.gap : FR_.pre, { g: chf(gap) }) : (inCart ? FR_.free : FR_.preFree);
    el.classList.toggle('is-free', gap <= 0); el.classList.toggle('is-gap', gap > 0);
  }
  root.addEventListener('click', function (e) {
    if (!e.target.closest('[data-q5-free]')) return;
    var t = document.querySelector('[data-q5p]'); if (t) t.scrollIntoView({ behavior: cfg.reduced ? 'auto' : 'smooth', block: 'start' });
  });
  function loadCart() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (c) { renderProgress((c.total_price || 0) / 100); stickyCart(c); freeLine(c); try { document.dispatchEvent(new CustomEvent('q5:cart', { detail: c })); } catch (e) {} return c; }).catch(function () { renderProgress(0); });
  }
  requestAnimationFrame(function () { setTimeout(loadCart, 60); });
  // Netzwerk-Wache — einmal pro Seite, mit Fehlerpfad
  if (!window.__q5CartPatched) {
    window.__q5CartPatched = true;
    var re = /\/cart\/(add|change|update|clear)/;
    var of = window.fetch;
    window.fetch = function (u) { var p = of.apply(this, arguments); try { if (re.test(typeof u === 'string' ? u : (u && u.url) || '')) p.then(function () { setTimeout(loadCart, 150); }, function () {}); } catch (e) {} return p; };
    var oo = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, u) { try { if (re.test(u)) this.addEventListener('load', function () { setTimeout(loadCart, 150); }); } catch (e) {} return oo.apply(this, arguments); };
  }

  /* ---------- «Ergänzt dein Ritual»: Schliesser der Lücke zuerst ---------- */
  function reorderRitual(gap) {
    var list = document.querySelector('[data-q5-complements]');
    if (!list) return;
    var items = Array.prototype.slice.call(list.children);
    items.sort(function (a, b) {
      var pa = parseFloat(a.getAttribute('data-price')), pb = parseFloat(b.getAttribute('data-price'));
      var ca = pa >= gap ? 0 : 1, cb = pb >= gap ? 0 : 1;
      if (ca !== cb) return ca - cb;
      return ca === 0 ? pa - pb : pb - pa;
    });
    items.forEach(function (it) { list.appendChild(it); });
  }

  /* ---------- Nächster Schritt nach «In den Warenkorb» (Handy/Tablet, 05.10.2026) ----------
     Befund 05.10. (QUOALA-BUSINESS/daryl-update-2026-10-05/antwort/BEFUND.md): am Handy öffnet sich nach dem Hinzufügen nichts,
     nur die Zahl am Warenkorb-Symbol wechselt. Darum eine feste Leiste unten: «Im Warenkorb» + «Zur Kasse» + «Warenkorb ansehen».
     Nur < 990 px (am Desktop öffnet die Schublade). Bleibt, bis sie geschlossen wird. Schreibt nichts in den Warenkorb. */
  var NX = {
    de: { ok: 'Im Warenkorb', go: 'Zur Kasse', cart: 'Warenkorb ansehen', close: 'Schliessen' },
    en: { ok: 'Added to cart', go: 'Checkout', cart: 'View cart', close: 'Close' },
    fr: { ok: 'Ajouté au panier', go: 'Commander', cart: 'Voir le panier', close: 'Fermer' }
  };
  function showNext(btn) {
    if (!(window.matchMedia && window.matchMedia('(max-width: 989px)').matches)) return;
    var t = NX[cfg.locale] || NX.de, el = document.querySelector('[data-q5-next]');
    if (!el) {
      var st = document.createElement('style');
      st.textContent = '.q5-next{position:fixed;left:0;right:0;bottom:0;z-index:2147483000;display:flex;align-items:center;gap:10px;padding:10px 12px calc(10px + env(safe-area-inset-bottom));background:#fff;border-top:1px solid #E0E0E0;box-shadow:0 -6px 18px rgba(13,19,33,.10);font-family:Manrope,system-ui,sans-serif;color:#0D1321}' +
        '.q5-next[hidden]{display:none}.q5-next__ok{flex:1 1 auto;min-width:0;font-size:15px;line-height:20px;font-weight:600}.q5-next__ok a{display:block;font-size:14px;font-weight:400;color:#0D1321;text-decoration:underline;text-underline-offset:3px}' +
        '.q5-next__go,.q5-next__go:hover,.q5-next__go:visited{flex:none;display:inline-flex;align-items:center;justify-content:center;min-height:48px;padding:0 22px;border-radius:6px;font-size:16px;font-weight:600;text-decoration:none;color:#fff!important}' +
        '.q5-next__x{flex:none;width:36px;height:44px;border:0;background:none;font-size:22px;line-height:1;color:#0D1321;padding:0}';
      document.head.appendChild(st);
      el = document.createElement('div'); el.className = 'q5-next'; el.setAttribute('data-q5-next', ''); el.setAttribute('role', 'status');
      var src = document.querySelector('[data-q5-form] .q5-btn') || btn, bg = src ? getComputedStyle(src).backgroundColor : '#0D1321';
      el.innerHTML = '<span class="q5-next__ok">✓ ' + t.ok + '<a href="' + ROOT + 'cart">' + t.cart + '</a></span>' +
        '<a class="q5-next__go" href="/checkout?locale=' + (NX[cfg.locale] ? cfg.locale : 'de') + '" style="background:' + bg + '">' + t.go + '</a>' +
        '<button type="button" class="q5-next__x" aria-label="' + t.close + '">×</button>';
      el.querySelector('.q5-next__x').addEventListener('click', function () { el.hidden = true; });
      document.body.appendChild(el);
    }
    el.hidden = false;
  }

  /* ---------- Add to cart (Hauptformular, Sticky, Karten) ---------- */
  function addToCart(id, btn, label) {
    if (btn.classList.contains('is-busy')) return;
    btn.classList.add('is-busy');
    var err = root.querySelector('[data-q5-error]'); if (err) { err.textContent = ''; err.hidden = true; }
    return fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        btn.classList.add('is-done');
        if (label) { var span = btn.querySelector('[data-q5-label]'); if (span) { span.textContent = T.added; setTimeout(function () { span.textContent = T.add; }, 2200); } }
        setTimeout(function () { btn.classList.remove('is-done'); btn.classList.remove('is-busy'); }, 2200);
        document.dispatchEvent(new CustomEvent('q5:added'));
        showNext(btn);
        try { var ac = window.PXUTheme && window.PXUTheme.jsAjaxCart; if (ac) { if (ac.updateView) ac.updateView(); if (ac.showDrawer) ac.showDrawer(); } } catch (e) {}
      })
      .catch(function () { btn.classList.remove('is-busy'); if (err) { err.textContent = T.error; err.hidden = false; } });
  }
  var form = root.querySelector('[data-q5-form] form');
  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    var id = form.querySelector('[name="id"]').value;
    var btn = form.querySelector('.q5-btn');
    addToCart(id, btn, true);
  });
  var stickyBtn = document.querySelector('[data-q5-sticky-add]');
  if (stickyBtn) stickyBtn.addEventListener('click', function () { addToCart(stickyBtn.getAttribute('data-variant'), stickyBtn, true); });
  document.querySelectorAll('[data-q5-add]').forEach(function (b) {
    b.addEventListener('click', function () { addToCart(b.getAttribute('data-q5-add'), b, false); });
  });

  /* ---------- Bewertungs-Link → Judge.me-Widget (Sektions-ID ist je Vorlage anders) ---------- */
  var rl = root.querySelector('[data-q5-reviews-link]');
  if (rl) rl.addEventListener('click', function (e) {
    var w = document.querySelector('.jdgm-rev-widg, .jm-review-widget, .jdgm-review-widget');
    if (w) { e.preventDefault(); w.scrollIntoView({ behavior: cfg.reduced ? 'auto' : 'smooth', block: 'start' }); }
  });

  /* ---------- Galerie ---------- */
  var items = root.querySelectorAll('[data-q5-media]');
  var thumbs = root.querySelectorAll('[data-q5-thumb]');
  // 02.10. (Tempo): Galeriebilder 2+ kommen ohne src (data-q5-src) – nachladen nach dem Seitenaufbau oder sofort bei Bedarf
  function hydrate(el) {
    [].forEach.call((el || root).querySelectorAll('img[data-q5-src]'), function (img) {
      if (img.dataset.q5Srcset) img.srcset = img.dataset.q5Srcset;
      img.src = img.dataset.q5Src; img.removeAttribute('data-q5-src'); img.removeAttribute('data-q5-srcset');
    });
    // 09.10. (Tempo): Video-Poster ebenso erst nach dem Seitenaufbau (data-q5-poster)
    [].forEach.call((el || root).querySelectorAll('video[data-q5-poster]'), function (v) {
      v.poster = v.dataset.q5Poster; v.removeAttribute('data-q5-poster');
    });
  }
  if (document.readyState === 'complete') setTimeout(function () { hydrate(); }, 200);
  else window.addEventListener('load', function () { setTimeout(function () { hydrate(); }, 200); });
  function show(i) {
    if (items[i]) hydrate(items[i]);
    items.forEach(function (it, k) { it.classList.toggle('is-active', k === i); var v = it.querySelector('video'); if (v) { if (k === i) { v.play().catch(function () {}); } else { v.pause(); } } });
    thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
  }
  thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
  // Wischen auf der Bühne (Handy): horizontal ≥ 40 px und deutlicher als vertikal → nächstes/vorheriges Bild
  var stage = root.querySelector('.q5-stage');
  if (stage && items.length > 1) {
    var sx = 0, sy = 0, swiping = false;
    function current() { for (var k = 0; k < items.length; k++) if (items[k].classList.contains('is-active')) return k; return 0; }
    stage.addEventListener('touchstart', function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; swiping = true; hydrate(); }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (!swiping) return; swiping = false;
      var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
      // 21.09.: Endlos — nach dem letzten Bild wieder das erste, vor dem ersten das letzte
      var i = current(), n = items.length, j = dx < 0 ? (i + 1) % n : (i - 1 + n) % n;
      show(j);
      var th = thumbs[j];
      if (th && th.scrollIntoView) th.scrollIntoView({ block: 'nearest', inline: 'center', behavior: cfg.reduced ? 'auto' : 'smooth' });
    }, { passive: true });
  }

  /* ---------- Sticky-Knopf ---------- */
  var sticky = document.querySelector('[data-q5-sticky]');
  var mainBtn = root.querySelector('.q5-form .q5-btn');
  // Scroll statt IntersectionObserver: springt der Knopf in einem Frame von unterhalb nach oberhalb
  // des Viewports (Anker, schneller Flick), wechselt der Schnittstatus nicht und IO feuert nie.
  if (sticky && mainBtn) {
    var stickyShown = null, stickyTick = false;
    var updateSticky = function () {
      stickyTick = false;
      // 21.09.: sichtbar, sobald der Hauptknopf nicht im Bild ist — auch bevor man ihn erreicht hat (Gregory: Knopf sofort greifbar)
      var r = mainBtn.getBoundingClientRect();
      var show = r.bottom < 0 || (r.top > window.innerHeight && window.scrollY > 160);
      document.documentElement.classList.toggle('q5-sticky-on', show);
      if (show === stickyShown) return;
      stickyShown = show;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
    };
    window.addEventListener('scroll', function () { if (!stickyTick) { stickyTick = true; requestAnimationFrame(updateSticky); } }, { passive: true });
    window.__q5StickyUpdate = updateSticky;
    updateSticky();
  }

  /* ---------- Reveal + Parallax ---------- */
  if (!cfg.reduced && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.2 });
    document.querySelectorAll('.q5-reveal').forEach(function (el) { io.observe(el); });

    var px = Array.prototype.slice.call(document.querySelectorAll('.q5-parallax'));
    if (px.length) {
      var ticking = false;
      var onScroll = function () {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () {
          var vh = window.innerHeight;
          px.forEach(function (el) {
            var r = el.getBoundingClientRect();
            if (r.bottom < 0 || r.top > vh) return;
            var p = (r.top + r.height / 2 - vh / 2) / vh; // -0.5..0.5
            el.style.transform = 'translateY(' + (p * -56).toFixed(1) + 'px) scale(1.12)';
          });
          ticking = false;
        });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  } else {
    document.querySelectorAll('.q5-reveal').forEach(function (el) { el.classList.add('is-in'); });
  }
})();

/* 25.09.2026 Judge.me-Karussell (Desktop): Endzustände sichtbar, kein Endlos-Sprung.
   05.10.2026 (Greg: «nur eine Karte weiter – ridiculous»): Pfeile blättern um alle sichtbaren Karten (Desktop 4), nicht mehr um eine.
   05.10.2026 (Greg: «durchgängig – am Ende wieder am Anfang»): Pfeil rechts am Ende springt an den Anfang, Pfeil links am Anfang ans Ende; Pfeile nur blass, wenn alle Karten ohnehin sichtbar sind. */
(function () {
  function wire() {
    var tr = document.querySelector('.jm-carousel__track');
    var nx = document.querySelector('.jdgm-carousel-review-list__nav--next');
    var pv = document.querySelector('.jdgm-carousel-review-list__nav--prev');
    if (!tr || !nx || !pv || tr.__q5) return !!tr;
    tr.__q5 = true;
    // Judge.me-Autoplay (alle ~5 s 4 Karten weiter + Rücksprung) abschalten: nur unsere Aufrufe dürfen den Track programmatisch bewegen.
    var ours = false;
    var P = Element.prototype, dsc = Object.getOwnPropertyDescriptor(P, 'scrollLeft');
    ['scrollTo', 'scroll', 'scrollBy'].forEach(function (m) { var f = P[m]; tr[m] = function () { if (ours) return f.apply(tr, arguments); }; });
    Object.defineProperty(tr, 'scrollLeft', { get: function () { return dsc.get.call(tr); }, set: function (v) { if (ours) dsc.set.call(tr, v); } });
    function step() { var c = tr.children; return c.length > 1 ? c[1].offsetLeft - c[0].offsetLeft : tr.clientWidth; }
    function upd() { var none = tr.scrollWidth - tr.clientWidth < 4; pv.classList.toggle('q5-off', none); nx.classList.toggle('q5-off', none); }
    var target = null;
    function go(d, e) {
      if (window.innerWidth < 750) return; e.preventDefault(); e.stopImmediatePropagation();
      var st = step(), max = tr.scrollWidth - tr.clientWidth;
      var base = target !== null ? target : tr.scrollLeft;
      var n = Math.max(1, Math.round(tr.clientWidth / st));
      var idx = Math.round(base / st) + d * n;
      target = Math.max(0, Math.min(max, idx * st));
      if (d > 0 && base >= max - 4) target = 0; else if (d < 0 && base < 4) target = max;
      ours = true; tr.scrollTo({ left: target, behavior: 'smooth' }); ours = false;
      clearTimeout(tr.__q5t); tr.__q5t = setTimeout(function () { target = null; upd(); }, 700);
    }
    nx.addEventListener('click', function (e) { go(1, e); }, true);
    pv.addEventListener('click', function (e) { go(-1, e); }, true);
    // Judge.me springt beim Scrollen im Endlos-Modus zurück: dessen scroll-Listener auf dem Track abfangen (Capture auf window läuft vorher).
    window.addEventListener('scroll', function (e) { if (e.target === tr) { e.stopImmediatePropagation(); requestAnimationFrame(upd); } }, true);
    tr.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
    upd();
    return true;
  }
  if (wire()) return;
  var n = 0, t = setInterval(function () { if (wire() || ++n > 60) clearInterval(t); }, 500);
})();
